import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

const TermsModal = ({ onClose }) => {
  return (
    <Dialog open maxWidth="md" fullWidth>
      <DialogTitle>Terms & conditions</DialogTitle>
      <DialogContent>
        <div>
          <Typography>
            We reserve the right to cancel, modify or terminate the Referral
            Program at any time for any reason.
          </Typography>
          <Typography>
            We reserve the right to disqualify any referred lead at any time at
            WeAdmit’s sole discretion.
          </Typography>
          <Typography>
            We may, from time to time, update these Terms of Participation.
          </Typography>
          <Typography>
            Without limiting the generality of the foregoing, you agree that you
            will not (i) violate any law, infringe or violate the rights of any
            third party, or otherwise act in a manner that could reasonably be
            deemed harassing, harmful, illegal, hateful, obscene or outside the
            spirit and intent of WeAdmit and its programs and operations; (ii)
            act in any way as to disparage the name or reputation of WeAdmit or
            its affiliates; or (iii) use the WeAdmit name or marks in connection
            with unrelated or controversial topics or statements, including
            those that are political, obscene, or otherwise offensive or
            objectionable in nature.
          </Typography>
          <Typography>
            In the event, a Referral Reward is issued in error or is obtained by
            fraud, deceit, or any unlawful, prohibited, or unauthorized means,
            We reserve the right to revoke or cancel the issued reward at our
            sole and absolute discretion.
          </Typography>
          <Typography>
            You may not refer yourself or represent that you referred a client
            unless you did, indeed, refer that client. Should We receive
            multiple referrals for a prospective client from an individual
            referring User, We will only issue one reward to the eligible
            referring User. Should We receive referrals for a prospective client
            from multiple referring Users, We will issue one reward to a single,
            eligible referring User subject to our discretion and fair
            determination.In addition to reviewing these Terms, it is import
            that You review the{' '}
            <Link href="https://weadmit.com/terms/" target="_blank">
              WeAdmit Terms of Use
            </Link>{' '}
            and{' '}
            <Link target="_blank" href="https://weadmit.com/privacy/">
              Privacy Policy
            </Link>
            , which are incorporated herein by reference and without limitation,
            including their terms which may be updated from time to time, as
            these Terms apply to all Users of the WeAdmit website. Please note
            that the personal information collected, processed, and used as part
            of the Referral Program will be used in accordance with WeAdmit’s
            Privacy Policy. If you object to anything in these Terms, the Terms
            of Use, or the Privacy Policy (collectively, the “WeAdmit
            Policies”), do not participate in the Referral Program.
            <br />
            In addition to reviewing these Terms, it is important that You
            review the{' '}
            <Link href="https://weadmit.com/terms/" target="_blank">
              WeAdmit Terms of Use
            </Link>{' '}
            and{' '}
            <Link target="_blank" href="https://weadmit.com/privacy/">
              Privacy Policy
            </Link>
            , which are incorporated herein by reference and without limitation,
            including their terms which may be updated from time to time, as
            these Terms apply to all Users of the WeAdmit website. Please note
            that the personal information collected, processed, and used as part
            of the Referral Program will be used in accordance with WeAdmit’s
            Privacy Policy. If you object to anything in these Terms, the Terms
            of Use, or the Privacy Policy (collectively, the “WeAdmit
            Policies”), do not participate in the Referral Program.
          </Typography>
        </div>
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="contained" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsModal;
